// extracted by mini-css-extract-plugin
export default {"content":"eMigCiFseTmttX4LJV7Q"};